// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.beAucRec1FUnV8 {
  width: 100%;
  margin-bottom: var(--ds-space-400, 32px);
}
.RTZgPDUCpAfjyN {
  display: flex;
  padding: var(--ds-space-0, 0) var(--ds-space-200, 15px) var(--ds-space-100, 8px) var(--ds-space-200, 15px);
  border-radius: var(--ds-radius-small, 3px);
  background: var(--ds-background-information, #e9f2ff);
}
.AVuHGswxE51c8O {
  padding: var(--ds-space-250, 21px) var(--ds-space-200, 15px) var(--ds-space-0, 0) var(--ds-space-200, 15px);
  border: 1px solid var(--ds-border-information, #1d7afc);
}
.AVuHGswxE51c8O tr:last-child {
  border-bottom: none;
}
.jxBgc8YxP6A6XM {
  margin-top: var(--ds-space-150, 12px);
  margin-bottom: var(--ds-space-075, 5px);
  color: var(--ds-text-subtle, #44546f);
  font-size: 13px;
  text-decoration: underline;
}
.jxBgc8YxP6A6XM:hover {
  cursor: pointer;
}
.NrQrtinfVVhr41 {
  margin-top: var(--ds-space-150, 12px);
  margin-right: var(--ds-space-075, 6px);
}
.eXdCVrenrcqRrj {
  margin-top: var(--ds-space-150, 12px);
  margin-right: var(--ds-space-100, 8px);
  padding-top: var(--ds-space-0, 0);
}
.jW_UTUa0XTXPHJ {
  display: flex;
  flex-wrap: wrap;
  padding-top: var(--ds-space-025, 2px);
}
`, ""]);
// Exports
export var banner = `beAucRec1FUnV8`;
export var summary = `RTZgPDUCpAfjyN`;
export var details = `AVuHGswxE51c8O`;
export var link = `jxBgc8YxP6A6XM`;
export var text = `NrQrtinfVVhr41`;
export var icon = `eXdCVrenrcqRrj`;
export var label = `jW_UTUa0XTXPHJ`;
export default ___CSS_LOADER_EXPORT___;
